var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9903 9.00001L7.6875 12.3028L7.6875 5.6972L10.9903 9.00001Z",
    fill: "#595D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDropdownArrow);
export default __webpack_public_path__ + "static/media/sidebarDropdownArrow.12760c41216cf55f61a55c39204ce52f.svg";
export { ForwardRef as ReactComponent };